<template>
  <lu-vbox lu-flex class="app-container">

    <lu-item>
      <PageHeader :title='$t("Users")' :hasReload='true' :hasDownLoad='true' @reload='reload'/>
    </lu-item>

    <lu-vbox class="searchBox">
      <lu-hbox class='searchDivTitle pad-in-5' lu-vcenter lu-click @click='searchExpanded=!searchExpanded'>
        <lu-item lu-click class="el-icon-arrow-right blc-icon" style='font-size:0.85rem;' :class='searchExpanded ? "isActive" : ""'  />
        <lu-item>{{ $t('search.search') }} </lu-item>
      </lu-hbox>

      <template v-if='searchExpanded'>
        <el-form :model='formQuery' ref="formQuery" label-width="100px">
          <lu-hbox lu-flex-wrap style='justify-content: end'>
            <el-form-item :label="$t('Login')" prop="login" class='mar-r-20'>
              <el-input v-model="formQuery.login" clearable :placeholder="$t('Login')" />
            </el-form-item>

            <el-form-item :label="$t('First name')" prop="firstName" class='mar-r-20'>
              <el-input v-model="formQuery.userFirstName" clearable :placeholder="$t('First name')" />
            </el-form-item>

            <el-form-item :label="$t('Last name')" prop="lastName" class='mar-r-20'>
              <el-input v-model="formQuery.userLastName" clearable :placeholder="$t('Last name')" />
            </el-form-item>

            <el-form-item :label="$t('Role')" prop="roleId" sclass='mar-r-20'>
              <el-select multiple collapse-tags v-model="formQuery.roleId" :placeholder="$t('Role')" clearable>
                <el-option v-for='item in roleList' :key='item.roleId' :label='item.label' :value='item.roleId'></el-option>
              </el-select>
            </el-form-item>

            <el-form-item :label="$t('Status')" prop="status" class='mar-r-20'>
              <el-select v-model="formQuery.statusId" :placeholder="$t('Status')" clearable>
                <el-option v-for='item in userStatusList' :key='item.id' :label='item.label' :value='item.id'></el-option>
              </el-select>
            </el-form-item>
          </lu-hbox>
        </el-form>

         <lu-hbox lu-hcenter class='pad-in-5 mar-t-10 mar-b-10'>
          <lu-item><el-button icon="el-icon-search" @click="handleSearch('formQuery')">{{ $t('action.search') | upperCase }}</el-button></lu-item>
          <lu-item><el-button icon="el-icon-close"  @click="handleCancel('formQuery')">{{ $t('action.cancel') | upperCase }}</el-button></lu-item>
          <lu-item><el-button icon="el-icon-edit"   v-permission='["adminUserEdit"]' @click="handleCreate('formQuery')">{{ $t('action.create')| upperCase }}</el-button></lu-item>
        </lu-hbox>
      </template>
    </lu-vbox>


    <lu-scroll-area lu-flex :scrollbarWidth='10' style='padding-right: 10px;'>
      <el-table
         v-loading="listLoading"
         class='table'
         :data="dataList"
         fit
         striped
         highlight-current-row
         style="width: 100%;"
         :row-class-name="tableRowClassName"
         @selection-change="handleSelectionChange"
         @sort-change="sortChange"
      >

        <el-table-column
          type="selection"
          align='center'
          width="50"
          :selectable='selectableRow'
        />
        <el-table-column align="left" :label="$t('Login')"     sortable prop="login"          />
        <el-table-column align="left" :label="$t('Name')"      sortable prop="userName"       />
        <el-table-column align="left" :label="$t('Role')"      sortable prop="userRoleLabel"  />
        <el-table-column align="left" :label="$t('E-mail')"    sortable prop="userEmail"      />
        <el-table-column align="center" :label="$t('Status')"  sortable prop="statusLabel"     >
          <template slot-scope="scope">
            <el-tag style='width:150px;' size="mini" :type='statusActiveClass(scope.row.statusId)'>
              <i :class="statusActiveName(scope.row.statusId)" style='margin-right: 5px;' />
                {{ scope.row.userStatusLabel }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('Is admin')"     sortable prop="isAdminBool"      >
          <template slot-scope="scope">
            <el-checkbox disabled v-model="scope.row.isAdminBool" />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          :label='$t("Actions")'
        >
          <template slot-scope="scope">
            <lu-hbox>
              <el-tooltip class="item" :effect="styleTooltip" :content="$t('Regenerate account code')" placement="right-start" v-if="$acl.isAllowed('adminUserEdit') && (scope.row.statusId === 5)">
                <el-button size="mini" class='icon' icon="el-icon-message success" @click='regenerateAccountCode(scope.row.userEmail)' />
              </el-tooltip>

              <el-button size="mini" class='icon' :icon="$acl.isAllowed('adminUserEdit') ? 'el-icon-edit success' : 'el-icon-view success'"  @click='handleEdit(scope.row)'/>
              <el-button size="mini" class='icon' icon="el-icon-delete error"  @click.stop='handleDelete([{ userId: scope.row.userId }])' v-if="$acl.isAllowed('adminUserEdit') && (scope.row.statusId === 4 || scope.row.statusId === 5)"/>
            </lu-hbox>
          </template>
        </el-table-column>
      </el-table>

      </lu-scroll-area>

      <pagination v-show="totalCount>0" :total="totalCount" :page="currentPage" :limit="pageSize"
          :hasDelete='multipleSelection.length>0'
          @deleteSelectedItem="deleteSelectedItem"
          @pagination="getPageFromPagination"
       />

  </lu-vbox>
</template>

<script>
import BaseController from '@/controllers/BaseController'
import { LuVbox, LuHbox, LuItem, LuScrollArea } from 'lusis-ui'
import Pagination from '@/components/Pagination'
import PageHeader from '@/components/PageHeader'
import userMixin from './mixin'
import { mapGetters } from 'vuex'

export default {
  name: 'adminUserList',
  extends: BaseController,
  mixins: [ userMixin ],
  components: { Pagination, PageHeader, LuVbox, LuHbox, LuItem, LuScrollArea },
  data: function () {
    return {
      searchExpanded: true,
      dataList: null,
      listLoading: true,
      conditions: [],
      order: '',
      multipleSelection: [],
      downloadLoading: false,
      formQuery: {
        login: null,
        userFirstName: null,
        userLastName: null,
        statusId: null,
        roleId: null
      }
    }
  },
  watch: {
    roleListReady(value) {
      if (value) {
        this.getPage(this.currentPage)
      }
    }
  },
  created: function () {
    // this.getPage(this.currentPage)
  },
  filters: {
    statusLabel(status) {
      return status === 1 ? 'Active' : 'Inactive'
    },
    statusFilter(status) {
      return status === 1 ? 'success' : 'warning'
    },
    upperCase(str) {
      return str.toUpperCase()
    }
  },
  computed : {
    ...mapGetters([ 'userStatusList', 'isAdmin', 'pageSize', 'theme' ]),
    styleTooltip: function () {
      return this.theme !== 'light-theme' ? 'dark' : 'light'
    },
    roleListReady: function () {
      if (this.$asyncComputed.roleList) {
        return this.$asyncComputed.roleList.success
      }
      return false 
    }
  },
  methods: {
    pageControllerName: function () {
      return 'adminUserList'
    },
    tableRowClassName({rowIndex}) {
      if (rowIndex % 2 === 0) {
        return 'odd-row';
      } else {
        return 'even-row';
      }
    },
    deleteSelectedItem () {
      let cond = this.multipleSelection.map(item => {
        return { userId: item.userId }
      })
      this.handleDelete(cond)
    },
    handleEdit (row) {
      let { params, meta } = this.$route
      let title = (meta && meta.title) ? meta.title + ':' + row.label : row.label
      let routePage = {
        fullpath: '/admin/user/edit',
        name: 'adminUserEdit',
        meta: meta,
        title: title,
        params: Object.assign({ recordId: row.userId, recordLabel: row.login },params)
      }

      routePage.params = Object.assign({ recordId: row.userId, recordLabel: row.login }, this.$route.params)
      return this.viewEdit(routePage, false, true, false, this.dataList.map(c => {
        return {
          id: c.userId,
          label: c.login
        }
      }))
    },
    handleCreate() {
      let routePage = { fullpath: '/admin/user/edit', name: 'adminUserEdit', params: { } }
      return this.viewEdit(routePage, true, true, false, [])
    },
    selectableRow (row) {
      return !(row.statusId in [ 1, 5, 6])
    },
    reload () {
      this.getPage(this.currentPage)
    },
    setCondition() {
      this.conditions = []
      if (this.formQuery.label) this.conditions.push({ 'field name': 'label', operator: 'like', value: [ '%' + this.formQuery.label + '%' ] })
      if (this.formQuery.login) this.conditions.push({ 'field name': 'login', operator: 'like', value: [ '%' + this.formQuery.login + '%' ] })
      if (this.formQuery.userFirstName) this.conditions.push({ 'field name': 'userFirstName', operator: 'like', value: [ '%' + this.formQuery.userFirstName + '%' ] })
      if (this.formQuery.userLastName) this.conditions.push({ 'field name': 'userLastName', operator: 'like', value: [ '%' + this.formQuery.userLastName + '%' ] })
      this.conditions.push('statusId')
      this.conditions.push('roleId')
    },
    getPageFromPagination(val) {
      this.currentPage = val.page
      this.getPage(this.currentPage)
    },
    getPage: function (page) {
      this.listLoading = true
      this.setCondition()
      this.searchData(
        'searchUser',
        page,
        this.conditions,
        null,
        { },
        row => {
          row['userName'] = row.userFirstName + ' ' + row.userLastName
          row['statusLabel'] = this.getLabel(this.userStatusListById, row.statusId, 'label')
          let role = this.roleList.find(p => p.roleId === row.roleId)
          row['userRoleLabel'] = role ? role.label : ''
          row['isAdminBool'] = row.isAdmin === 1
          row['userStatusLabel'] = this.getLabel(this.userStatusListById, row.statusId, 'label')
          return true
        },
        function () {
          this.resultExpanded = true
          this.listLoading = false
        }.bind(this),
        'userList',
        this.formQuery
      )
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    handleSearch(formName) {
      if (this.$refs[formName].validate()) {
        this.getPage(1)
      }
    },
    sortChange(data) {
      const { prop, order } = data
      this.order = prop + ' ' + (order === 'ascending' ? 'ASC' : 'DESC')
      this.getPage(this.currentPage)
    },
    handleCancel (formName) {
      this.reset()
      this.conditions = []
      this.$refs[formName].resetFields()
      this.resultExpanded = false
      this.getPage(this.currentPage)
    },
    statusActiveClass (type) {
      if (type === 1) return 'success'
      else if (type === 2 || type === 3) return 'primary'
      else if (type === 4 || type === 5) return 'danger'
      return 'warning'
    },
    statusActiveName (type) {
      if (type === 1) return 'el-icon-success'
      else if (type === 4 || type === 5) return 'el-icon-loading'
      else return 'el-icon-check'
    }
  }
}
</script>
